import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import api from "../lib/api";
import { formatDistanceToNow } from "date-fns";

export default function NotificationsBell() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({ items: [], unread: 0 });
  const ref = useRef(null);

  const load = () => api.get("/notifications").then((r) => setData(r.data)).catch(() => {});

  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const markRead = async (id) => {
    await api.post(`/notifications/${id}/read`);
    load();
  };
  const markAll = async () => {
    await api.post("/notifications/read-all");
    load();
  };

  return (
    <div className="relative" ref={ref} data-testid="notif-bell">
      <button onClick={() => setOpen((v) => !v)} className="relative w-8 h-8 rounded-[4px] flex items-center justify-center bg-white/[0.03] hover:bg-white/[0.08] border border-white/10 hover:border-[var(--tf-primary)]/50 text-zinc-400 hover:text-white transition-all duration-200 hover:scale-105" data-testid="notif-bell-btn">
        <Bell className="w-3.5 h-3.5" />
        {data.unread > 0 && (
          <span className="absolute -top-1 -right-1 min-w-[16px] h-[16px] px-1 rounded-full text-[9px] font-mono font-black flex items-center justify-center text-black shadow-lg" style={{ background: "var(--tf-primary)" }} data-testid="notif-count">{data.unread}</span>
        )}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-80 tf-surface-elev tf-clip-card z-50 shadow-2xl" data-testid="notif-panel">
          <div className="flex items-center justify-between px-4 py-3 border-b border-white/5">
            <h4 className="tf-section-title">Notifications</h4>
            {data.unread > 0 && (
              <button onClick={markAll} className="text-[10px] tf-mono text-zinc-400 hover:text-white" data-testid="notif-mark-all">mark all read</button>
            )}
          </div>
          <div className="max-h-96 overflow-y-auto divide-y divide-white/5">
            {data.items.length === 0 && <div className="p-6 text-zinc-500 text-xs tf-mono text-center">No notifications</div>}
            {data.items.map((n) => (
              <Link
                key={n.id}
                to={n.link || "#"}
                onClick={() => { markRead(n.id); setOpen(false); }}
                className={`block px-4 py-3 hover:bg-white/5 transition-colors ${!n.read ? "border-l-2 border-[var(--tf-primary)]" : ""}`}
                data-testid={`notif-item-${n.id}`}
              >
                <div className="text-sm text-zinc-100 font-semibold">{n.title}</div>
                {n.body && <div className="text-xs text-zinc-400 line-clamp-2 mt-0.5">{n.body}</div>}
                <div className="text-[10px] tf-mono text-zinc-500 mt-1">{formatDistanceToNow(new Date(n.created_at))} ago</div>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
